module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"modal__container\">\n\n    <div class=\"modal__wrapper\">\n        <div class=\"modal__title\">Eek, Something went wrong unexpectedly.</div>\n\n        <div class=\"modal__description\">\n            <p>Please make sure you're connected, and try refreshing the page.</p>\n        </div>\n\n        <div class=\"modal__buttons\">\n            <button class=\"button\">\n                <div class=\"button__text\" onclick=\"location.reload(true);\">Try again</div>\n            </button>\n        </div>\n\n        <div class=\"control__bar\">\n            <a href=\"#\" class=\"button__close\"></a>\n        </div>\n    </div>\n\n</div>")
  }
  return __output;

}